export default __webpack_public_path__ + "static/media/subvisual.ce68f470.png";